import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import PropTypes from "prop-types";
import { genericRequestErrorHandler } from "../../../../../../api";
import Loader from "../../../../../../components/Loader";
import { currencies } from "../../../../../../helpers";
import _ from "lodash";
import { DateTime } from "luxon";
import { useQuery } from "@tanstack/react-query";
import { retrieveVendorAccomodation } from "../../../../../../api/Vendor/Accommodation";
import VendorsDocuments from "../../../components/VendorsDocuments";
import ListPaymentTerms from "../../../components/paymentsTerms/ListPaymentTerms";
import { CustomButton } from "../../../../../../components/CustomButton";
import TabStrip from "../../../../../../components/TabStrip";
import VendorAccConfigLogsTab from "./VendorAccLogsTab";
import DepositStatments from "../../../../CommonCRMModals/DepositStatmentss/DepositStatment";
import ProformaStatments from "../../../../CommonCRMModals/Proforma/List";
import { Price } from "../../../../../../components/Price";

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};

const trueFalseMapping = {
  true: "Yes",
  false: "No",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailAccommodationModal: { ...modalGenericStyles.modal },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    display: "grid",
    padding: variables.double_gap,
    minHeight: "30vh",
    maxHeight: "70vh",
    overflow: "auto",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.normal_gap,
  },
  [`@media ${variables.media.smallscreen}`]: {
    cardBody: { justifyContent: "center" },
    row: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
});
const DetailAccommodationModal = ({ id, onClose }) => {
  const classes = styles();

  const [activeTab, setActiveTab] = useState("basicData");

  const menuTabs = {
    basicData: "Basic Data",
    paymentTerms: "Payment Terms",
    proforma: "Proforma Statment",
    creditStatments: "Credit Statements",
    documents: "Documents",
    logs: "Logs",
  };

  const { data: accommodation, isLoading: retrieveLoading } = useQuery({
    queryKey: ["DetailVendorAcc", id],
    queryFn: async () => {
      return retrieveVendorAccomodation({ id: id });
    },
    onError: (error) => genericRequestErrorHandler(error),
  });

  const basicDataCpl = [
    ["Id", "id"],
    ["Member", "member"],
    ["Market Type", "market_type"],
    [
      "Notify Amount",
      null,
      <Price
        currency={accommodation?.data?.vendor_data?.currency}
        price={accommodation?.data?.notify_amount}
      />,
    ],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(trueFalseMapping, _.get(accommodation, "data.payment_validation")),
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(accommodation, "data.cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(accommodation, "data.cxl_strategy_daysahead"),
    ],
    [
      "Block Non Refundable",
      null,
      _.get(trueFalseMapping, _.get(accommodation, "data.block_nonrefundable")),
    ],
    [
      "Status",
      null,
      _.get(statusOptions, _.get(accommodation, "data.status", "") || "N/A"),
    ],
  ];

  const creatorData = [
    ["Creator", "creator"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(accommodation, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  const editorData = [
    ["Last Editor", "last_editor"],
    [
      "Edited",
      null,
      DateTime.fromISO(_.get(accommodation, "data.edited")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];

  const VendorDataCpl = [
    [
      "Vendor",
      null,
      _.get(accommodation, "data.vendor", "").split("acc__")[1] || "N/A",
    ],

    [
      "Currency",
      null,
      _.get(currencies, _.get(accommodation, "data.vendor_data.currency")),
    ],
    ["Access Token", "access_token"],
    ["Afil", "afil"],
    ["Clausu", "clausu"],

    ["Codigousu", "codigousu"],
    ["Codusu", "codusu"],
    [
      "Secacc",
      null,
      _.get(accommodation, "data.vendor_data.secacc") === 0
        ? "0"
        : _.get(accommodation, "data.vendor_data.secacc") || "N/A",
    ],
    ["Static Key", "static_key"],
  ];

  const vendorContactData = [
    ["Title", "title"],
    ["First Name", "first_name"],
    ["Last Name", "last_name"],
    ["Email", "email"],
  ];

  const credentialsData = [
    [" Username", null, _.get(accommodation, "data.vendor_data.username", "")],
    ["Secret", "secret"],
    ["Password", null, _.get(accommodation, "data.vendor_data.password", "")],
    ["Agent Code", "agent_code"],
    ["Code", "code"],
    ["API Key", "apikey"],
    ["Api Password", "api_password"],
    ["Application Key", "application_key"],
    ["Client Code", "client_code"],
  ];

  return (
    <div id="DetailVendorAccModal" className={classes.DetailAccommodationModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Vendor Accommodation Details</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {retrieveLoading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicData" && (
                <React.Fragment>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Basic Data"}
                        cardInfo={basicDataCpl}
                        objectData={_.get(accommodation, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Creator Data"}
                        cardInfo={creatorData}
                        objectData={_.get(accommodation, "data", {})}
                      />
                      <GenericBasicInfo
                        header={"Editor Data"}
                        cardInfo={editorData}
                        objectData={_.get(accommodation, "data", {})}
                      />
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Data"}
                        cardInfo={VendorDataCpl}
                        objectData={_.get(
                          accommodation,
                          "data.vendor_data",
                          {}
                        )}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Contact Data"}
                        cardInfo={vendorContactData}
                        objectData={_.get(
                          accommodation,
                          "data.vendor_data.contact_details",
                          {}
                        )}
                      />
                      <GenericBasicInfo
                        header={"Vendor Credentials Data"}
                        cardInfo={credentialsData}
                        objectData={_.get(
                          accommodation,
                          "data.vendor_data",
                          {}
                        )}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "paymentTerms" && (
                <ListPaymentTerms
                  showAddButton={true}
                  vendorId={_.get(accommodation, "data.id")}
                />
              )}
              {activeTab === "proforma" && (
                <ProformaStatments
                  invalidationKey="DetailsSubAgentModal"
                  entityType="vendor"
                  entityData={_.get(accommodation, "data", {})}
                />
              )}
              {activeTab === "creditStatments" && (
                <DepositStatments
                  invalidationKey="DetailVendorAcc"
                  entityType="vendor"
                  entityData={_.get(accommodation, "data", {})}
                />
              )}
              {activeTab === "documents" && (
                <VendorsDocuments
                  queryKey={`vendor_accommodation_document`}
                  showAddButton={true}
                  tags={[`vendor__${_.get(accommodation, "data.id")}`]}
                  entityData={_.get(accommodation, "data", {})}
                />
              )}
              {activeTab === "logs" && <VendorAccConfigLogsTab />}
            </React.Fragment>
          )}
        </div>
        <div className={classes.modalCardActions}>
          <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailAccommodationModal.propTypes = {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DetailAccommodationModal;
